import React from 'react';
import { Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TextField } from '@/components/text-field';
export function AutoStoreConfigCard(p) {
    const { control, disabled, appStoreField, googlePlayField, fallbackField } = p;
    const { t } = useTranslation('campaign');
    return (<Card>
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Smartphone className="h-4 w-4"/>
                    {t('auto_store_config.card_title')}
                </CardTitle>
                <CardDescription>{t('auto_store_config.card_desc')}</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                <TextField control={control} name={appStoreField ?? 'appStoreUrl'} type="url" placeholder="https://apps.apple.com/app/id000000000" label={t('auto_store_config.app_store_url')} description={t('auto_store_config.app_store_desc')} disabled={disabled} autoComplete="off"/>
                <TextField control={control} name={googlePlayField ?? 'googlePlayUrl'} type="url" placeholder="https://play.google.com/store/apps/details?id=com.example" label={t('auto_store_config.play_store_url')} description={t('auto_store_config.play_store_desc')} disabled={disabled} autoComplete="off"/>
                <TextField control={control} name={fallbackField ?? 'fallbackUrl'} type="url" placeholder="https://example.com" label={t('auto_store_config.fallback_url')} description={t('auto_store_config.fallback_desc')} disabled={disabled} autoComplete="off"/>
            </CardContent>
        </Card>);
}
